import { IN_STORE_TURNAROUND_DAYS } from 'constants/turnaroundConstants';

export const formatDateForReminder = (dateTime: Date): string => {
  return dateTime.toLocaleString('en-US', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit',
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false
  });
};

export const convertFirebaseTimestampToDate = (timestamp: { seconds: number; nanoseconds: number }): Date => {
  return new Date(timestamp.seconds * 1000);
};

// `visitDate` is a UTC-midnight-keyed picker date — its UTC y/m/d ARE the store-local visit day.
// Add the turnaround in calendar days, then snap to 10:00 in the store timezone. This mirrors the
// retail post-due computation (backend `CollabService` retail path) so the day boundary is
// store-local and the slot card + the submitted reminder always resolve to the same day. `timezone`
// defaults to UTC for callers without a resolved store tz. The in-store deadline window is the
// collab/campaign turnaround (callers pass it; IN_STORE_TURNAROUND_DAYS is only the fallback) —
// NOT the creator's chosen (possibly sooner) turnaround.
export const getPostDueDate = (
  visitDate: Date,
  maxTurnaroundDays: number = IN_STORE_TURNAROUND_DAYS,
  timezone: string = 'UTC'
): Date => {
  const y = visitDate.getUTCFullYear();
  const m = visitDate.getUTCMonth();
  const d = visitDate.getUTCDate() + maxTurnaroundDays;
  const probe = new Date(Date.UTC(y, m, d, 10, 0, 0));
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  }).formatToParts(probe);
  const localH = Number(parts.find((p) => p.type === 'hour')!.value) % 24;
  const localM = Number(parts.find((p) => p.type === 'minute')!.value);
  const diffMs = ((localH - 10) * 60 + localM) * 60 * 1000;
  return new Date(probe.getTime() - diffMs);
};

export const formatShortDate = (date: Date): string =>
  date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });